export default __webpack_public_path__ + "static/media/AM.6bc0196a.pdf";